import React from 'react';

import GenericFullLoadingPage from '@core/myta/pages/GenericFullLoadingPage';
import { getClientSpecificEventFullLoadingPage } from '@helpers/clientSpecificUtils';

const EventFullLoadingPage = () => {
  const loaderElement = getClientSpecificEventFullLoadingPage();

  if (loaderElement) {
    return loaderElement;
  }

  return <GenericFullLoadingPage isAuthorized />;
};

export default EventFullLoadingPage;
